import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, isRef as _isRef, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-94e9ace8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pr-content"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "description-content" }
const _hoisted_4 = { class: "short-description-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/our-aroms",
  style: {"text-decoration":"underline","color":"red","margin-bottom":"1rem"}
}, "Подробнее об ароматизаторах", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Количество", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Допы", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Описание", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { style: {"width":"50%"} }
const _hoisted_15 = { key: 1 }

import PageTitle from '@/components/UI/PageTitle.vue';

    import { ref, Ref, computed} from "vue";
    import { ProductDops, ProductType } from './types'
    import { useRoute } from 'vue-router';

    import { API } from "@/api/modules/productData";
    import handleError from '@/tools/errorHandler'
    import Product from './ProductClass'
    import getImage from "@/tools/getImage";
    import getProductImage from "@/tools/getProductImage";
    import isImageExists from "@/tools/isImageExists";

    import AttributesView from "./AttributesView.vue";
    import AmountInput from "@/components/UI/AmountInput.vue";
    import DopsSection from "./DopsSection.vue";
    import PushProduct from './PushProduct.vue'
    import ButtonCustom from "../UI/ButtonCustom.vue";


    const DOPPING_PRICE = 5000 //50.00р
    
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductContent',
  setup(__props) {

    const route = useRoute();

    let show = ref(false)

    
    let product :Ref<ProductType | null> = ref(null)
    let viewProduct:Ref<Product | null> = ref(null)

    API.getProductById(Number(route.params.id))
        .then(res => {
            product.value = res.data
            if(product.value != null){
                viewProduct.value = new Product(
                        product.value.id, 
                        product.value.prices, 
                        product.value.name, 
                        product.value.description, 
                        product.value.discount, 
                        product.value.dops,
                        product.value.short_description
                    )
                console.log(viewProduct.value.dops[0].dopping == '')
            }
        })
        .catch( err => {
            handleError(err)
            product.value = null
        })

    let amount = ref(1)
    function getAmount(num:string){
        amount.value = Number(num)
    }

    let selectedDops:Ref<Array<number>> = ref([])
    function getSelectedDop(dops:any){
        selectedDops = dops
    }

    let priceId:Ref<number | null> = ref(null)
    let price:Ref<string| null> = ref(null)

    function getPrice(id:number, p:number){
        if(p == null){
            price.value = p
            priceId.value = id 
            return
        }
        priceId.value = id
        price.value = p.toString()
    }

    let computedPrice = computed(() => {
        let p = Number(price.value)
        let discount = 0

        if(viewProduct.value != null) {
            discount = viewProduct.value.discount
        }
        p = (p + DOPPING_PRICE * selectedDops.value.length) / 100 * (100 - discount) * amount.value
        return `${p.toString().slice(0, -2)}.${p.toString().slice(-2)} ДЕТЛ`
    })


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(viewProduct) != null)
      ? (_openBlock(), _createBlock(PageTitle, {
          key: 0,
          titleElement: _unref(viewProduct).name
        }, null, 8, ["titleElement"]))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      (_unref(viewProduct) != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h1", null, _toDisplayString(_unref(viewProduct).name), 1),
            (_unref(isImageExists)(`${_unref(viewProduct).id}_1000x1000.webp`))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(getProductImage)(`${_unref(viewProduct).id}_1000x1000.webp`)
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(viewProduct).short_description.toLowerCase()), 1),
              _hoisted_5,
              _createVNode(AttributesView, {
                onSelected: getPrice,
                attributes: _unref(viewProduct).attributes
              }, null, 8, ["attributes"]),
              _hoisted_6,
              _createVNode(AmountInput, { onSelectedAmount: getAmount }),
              (_unref(viewProduct).dops.length > 0 && _unref(viewProduct).dops[0].dopping != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(DopsSection, {
                      dops: _unref(viewProduct).dops,
                      onSelectedDop: getSelectedDop
                    }, null, 8, ["dops"])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_9,
              _createElementVNode("div", null, _toDisplayString(_unref(viewProduct).description), 1),
              _hoisted_10,
              (_unref(price) != null)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_11, "Стоимость: " + _toDisplayString(_unref(computedPrice)), 1))
                : _createCommentVNode("", true),
              _hoisted_12,
              _createVNode(PushProduct, {
                amount: _unref(amount),
                dops: _unref(selectedDops),
                price_id: _unref(priceId),
                product_id: Number(_unref(route).params.id),
                onToCart: _cache[0] || (_cache[0] = ($event: any) => (_isRef(show) //@ts-ignore
 ? show.value = true : show = true))
              }, null, 8, ["amount", "dops", "price_id", "product_id"]),
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_RouterLink, { to: {name: 'cart'} }, {
                  default: _withCtx(() => [
                    (_unref(show))
                      ? (_openBlock(), _createBlock(ButtonCustom, { key: 0 }, {
                          default: _withCtx(() => [
                            _createTextVNode("Перейти в корзину")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, " Грузится... "))
    ])
  ], 64))
}
}

})